import { useEffect, useState } from 'react';

export const isoDaysAhead = (days: number): string => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().split('T')[0];
};

const withCondition = (baseFilters: any | undefined, condition: any): any =>
  baseFilters ? { $and: [...baseFilters.$and, condition] } : { $and: [condition] };

export interface PermitStats {
  active: number;
  expired: number;
  expiringSoon: number;
}

/**
 * Status counts for the permits stat cards, computed server-side over the
 * whole filtered dataset (the visible page alone can't provide them).
 */
export function usePermitStats(
  service: { getAll: (options?: any) => Promise<any> },
  baseFilters: any | undefined,
  statusField: string,
  refreshKey = 0,
): PermitStats {
  const [stats, setStats] = useState<PermitStats>({ active: 0, expired: 0, expiringSoon: 0 });
  const filtersKey = JSON.stringify(baseFilters || {});

  useEffect(() => {
    let active = true;
    const count = (condition: any): Promise<number> =>
      service
        .getAll({ filters: withCondition(baseFilters, condition), pagination: { page: 1, pageSize: 1 } })
        .then((r: any) => r.meta?.pagination?.total ?? 0)
        .catch(() => 0);
    Promise.all([
      count({ [statusField]: { $eq: 'active' } }),
      count({ [statusField]: { $eq: 'expired' } }),
      count({ $and: [{ [statusField]: { $eq: 'active' } }, { expiryDate: { $lte: isoDaysAhead(30) } }] }),
    ]).then(([activeCount, expiredCount, expiringSoonCount]) => {
      if (active) setStats({ active: activeCount, expired: expiredCount, expiringSoon: expiringSoonCount });
    });
    return () => { active = false; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersKey, statusField, refreshKey]);

  return stats;
}
